<template>
  <div class="opage">
    <div>
      <!-- 状态筛选 -->
      <div class="tabs">
        <el-tabs v-model="datas.status" type="card" @tab-click="evaluationlist">
          <!-- 待确认 -->
          <!--2023/03/2 数字先不放,需要后端给接口 -->
          <el-tab-pane :label="$t('message.toBeConfirmed')" name="1">
          </el-tab-pane>
          <!-- 已确认 -->
          <el-tab-pane :label="$t('message.confirmed')" name="2">
          </el-tab-pane>
          <!-- 全部 -->
          <el-tab-pane :label="$t('message.all')" name="0">
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="table">
        <ol>
          <!-- 客户信息 -->
          <li>
            {{ $t("message.userInfo") }}1
          </li>
          <!-- 对应人员 -->
          <li>
            {{ $t("message.correspondingPerson") }}
          </li>
          <!-- 配送单号 -->
          <li class="flex2">
            {{ $t("message.porderNumber") }}
          </li>
          <!-- 评价时间 -->
          <li>
            {{ $t("message.evaluationTime") }}
          </li>
          <!-- 客户评价 -->
          <li class="flex2">
            {{ $t("message.customerTestimonials") }}
          </li>
          <!-- 配送单整体评价 -->
          <li class="flex2">
            {{ $t('message.overallEvaluationOfDeliveryOrder') }}
          </li>
          <!-- 处理备注 -->
          <li class="flex15">
            {{ $t("message.workWithNotes") }}
          </li>
          <!-- 确认状态（时间） -->
          <li>
            {{ $t("message.confirmTheStatus") }}({{ $t("message.times") }})
          </li>
        </ol>
        <ul v-for="(tableItem, tableIndex) in tableData" :key="tableIndex">
          <!-- 客户信息 -->
          <li>
            <div class="listShow">
              <p>{{ tableItem.porder && tableItem.porder.user ? tableItem.porder.user.id : '' }}</p>
              <p>{{ tableItem.porder && tableItem.porder.user ? tableItem.porder.user.realname : '' }}</p>
            </div>
          </li>
          <!-- 对应人员 -->
          <li>
            <div>
              <p>
                {{ tableItem.porder && tableItem.porder.y_admin ? tableItem.porder.y_admin.realname : '' }}
              </p>
              <p>
                {{ tableItem.porder && tableItem.porder.g_admin ? tableItem.porder.g_admin.realname : '' }}</p>
              <p>
                {{ tableItem.porder && tableItem.porder.p_admin ? tableItem.porder.p_admin.realname : '' }}
              </p>
            </div>
          </li>
          <!-- 配送单号 -->
          <li class="flex2">
            <router-link class="a-link" :to="'/porderDetail?is_japanfirm=1&porder_sn=' + tableItem.porder_sn"
              target="_blank">{{ tableItem.porder_sn }}
            </router-link>
          </li>
          <!-- 评价时间 -->
          <li>
            {{ tableItem.created_at }}
          </li>
          <!-- 客户评价 -->
          <li class="flex2">
            <div class="overallProductSatisfactionBox">
              <!-- 商品整体满意度 -->
              <p>
                <span>{{ $t('message.overallProductSatisfaction') }}</span>
                <el-rate disabled v-model="tableItem.goods_whole_score"></el-rate>
              </p>
              <!-- 服务整体满意度 -->
              <p>
                <span>{{ $t('message.overallServiceSatisfaction') }}</span>
                <el-rate disabled v-model="tableItem.service_whole_score"></el-rate>
              </p>
              <!-- 物流满意度 -->
              <p>
                <span>{{ $t('message.logisticsSatisfaction') }}</span>
                <el-rate disabled v-model="tableItem.logistics_whole_score"></el-rate>
              </p>
              <p>
                <!-- 查看明细 -->
                <el-button type="success" size="mini" @click="seeDetails(tableItem)">
                  {{ $t('message.viewDetails') }}
                </el-button>
              </p>
            </div>
          </li>
          <!-- 配送单整体评价 -->
          <li class="flex2">
            <div class="template">
              {{ tableItem.porder_desc }}
            </div>
          </li>
          <!-- 图片 -->
          <!-- <li class="imageLI">
              <div v-for="(imageItem, imageIndex) in tableItem.images" :key="imageIndex">
                <el-popover placement='right' trigger='hover'>
                  <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                  <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                </el-popover>
              </div>
            </li> -->
          <!-- 处理备注 -->
          <li class="flex15">
            <span>{{ tableItem.deal_remark }}</span>
          </li>
          <!-- 确认状态（时间） -->
          <li>
            <!-- 文本: 待确认 -->
            {{ tableItem.confirm_at ? tableItem.confirm_at : $t('message.toBeConfirmed') }}
          </li>
        </ul>
        <div v-if="tableData == false" class="No_data">暂无数据</div>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="detailshow">
      <div class="scoreInDetail">
        <!-- 配送单号 -->
        <h1>
          <span>
            <span>{{ $t('message.porderNumber') }}:</span>
            <span>{{ detailshowData.porder_sn }}</span>
          </span>
          <!-- 查看配送单 -->
          <router-link :to="'/porderDetail?is_japanfirm=1&porder_sn=' + detailshowData.porder_sn" target="_blank">
            <el-button type='primary' size="mini">
              {{ $t('message.viewTheDeliveryNote') }}
            </el-button>
          </router-link>
        </h1>
        <!-- 满意度为1到5星，星级越高越满意 -->
        <h2>{{ $t('message.satisfactionIs1To5Stars') }}</h2>
        <ul>
          <!-- 商品整体满意度 -->
          <li>
            <div class="row1">
              <!-- 文本: 商品整体满意度 -->
              <label>
                {{ $t('message.overallProductSatisfaction') }}:
              </label>
              <el-rate disabled v-model="detailshowData.goods_whole_score"></el-rate>
            </div>
          </li>
          <!-- 商品包装是否满意 -->
          <li>
            <div class="row1">
              <!--文本: 商品包装是否满意 -->
              <label>
                {{ $t('message.whetherTheProductPackagingIsSatisfactory') }}:
              </label>
              <el-rate disabled v-model="detailshowData.goods_pack_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" readonly v-model="detailshowData.goods_pack_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.goods_pack_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 商品质量是否符合您的预期 -->
          <li>
            <div class="row1">
              <!--文本: 商品质量是否符合您的预期 -->
              <label>
                {{ $t('message.whetherTheQualityOfTheProductMeetsYourExpectations') }}:
              </label>
              <el-rate disabled v-model="detailshowData.goods_quality_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" readonly v-model="detailshowData.goods_quality_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.goods_quality_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 商品是否完整（有无缺失，破损） -->
          <li>
            <div class="row1">
              <!--文本: 商品是否完整（有无缺失，破损） -->
              <label>
                {{ $t('message.whetherTheProductIsComplete') }}:
              </label>
              <el-rate disabled v-model="detailshowData.goods_complete_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" readonly v-model="detailshowData.goods_complete_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.goods_complete_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 服务整体满意度： -->
          <li>
            <div class="row1">
              <!--文本: 服务整体满意度： -->
              <label>
                {{ $t('message.overallServiceSatisfaction') }}:
              </label>
              <el-rate disabled v-model="detailshowData.service_whole_score"></el-rate>
            </div>
          </li>
          <!-- 服务流程是否满意 -->
          <li>
            <div class="row1">
              <!--文本:服务流程是否满意 -->
              <label>
                {{ $t('message.whetherTheServiceProcessIsSatisfactory') }}:
              </label>
              <el-rate disabled v-model="detailshowData.service_process_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" readonly v-model="detailshowData.service_process_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.service_process_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 服务人员是否能精准到位满足您的需求 -->
          <li>
            <div class="row1">
              <!--文本:服务人员是否能精准到位满足您的需求 -->
              <label>
                {{ $t('message.whetherTheServiceStaffIsInPlaceToMeetYourNeeds') }}:
              </label>
              <el-rate disabled v-model="detailshowData.service_admin_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" readonly v-model="detailshowData.service_admin_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.service_admin_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 服务人员是否态度良好 -->
          <li>
            <div class="row1">
              <!--文本:服务人员是否态度良好 -->
              <label>
                {{ $t('message.whetherTheServiceStaffHasAGoodAttitude') }}:
              </label>
              <el-rate disabled v-model="detailshowData.service_admin_attitude_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" readonly v-model="detailshowData.service_admin_attitude_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.service_admin_attitude_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 服务人员是否处理问题及时 -->
          <li>
            <div class="row1">
              <!--文本:服务人员是否处理问题及时 -->
              <label>
                {{ $t('message.whetherTheServiceStaffHandledTheProblemInATimelyManner') }}:
              </label>
              <el-rate disabled v-model="detailshowData.service_admin_speed_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" readonly v-model="detailshowData.service_admin_speed_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.service_admin_speed_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 物流满意度 -->
          <li>
            <div class="row1">
              <!--文本:物流满意度 -->
              <label>
                {{ $t('message.logisticsSatisfaction') }}:
              </label>
              <el-rate disabled v-model="detailshowData.logistics_whole_score"></el-rate>
            </div>
          </li>
          <!-- 对此物流速度是否满意 -->
          <li>
            <div class="row1">
              <!--文本:对此物流速度是否满意 -->
              <label>
                {{ $t('message.whetherYouAreSatisfiedWithTheSpeedOfThisLogistics') }}:
              </label>
              <el-rate disabled v-model="detailshowData.logistics_speed_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" readonly v-model="detailshowData.logistics_speed_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.logistics_speed_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 物流费用是否满意 -->
          <li>
            <div class="row1">
              <!--文本:物流费用是否满意 -->
              <label>
                {{ $t('message.whetherTheLogisticsCostsAreSatisfactory') }}:
              </label>
              <el-rate disabled v-model="detailshowData.logistics_fee_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" readonly v-model="detailshowData.logistics_fee_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.logistics_fee_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 物流服务（通关，配送等）是否满意 -->
          <li>
            <div class="row1">
              <!--文本:物流服务（通关，配送等）是否满意 -->
              <label>
                {{ $t('message.whetherTheLogisticsService') }}:
              </label>
              <el-rate disabled v-model="detailshowData.logistics_pass_score"></el-rate>
            </div>
            <div class="row2">
              <el-input type="textarea" readonly v-model="detailshowData.logistics_pass_score_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.logistics_pass_score_images"
                  :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 配送单整体评价： -->
          <li>
            <div class="row1">
              <!--文本:配送单整体评价： -->
              <label>
                {{ $t('message.overallEvaluationOfTheDeliveryOrder') }}:
              </label>
            </div>
            <div class="row2">
              <el-input type="textarea" readonly v-model="detailshowData.porder_desc"></el-input>
              <div class="imgBox">
                <div class="imgs" v-for="(imageItem, imageIndex) in detailshowData.porder_images" :key="imageIndex">
                  <el-popover placement='right' trigger='hover'>
                    <img :src='imageItem' alt='' style='width: 300px; height: 300px' />
                    <img :src='imageItem' class="backImg" @click="toImgePage(imageItem)" alt='' slot='reference' />
                  </el-popover>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    user_id: { type: Number }
  },
  data() {
    return {
      statusRange: "[]", //statusRange规则由split改成stringify,所以设置 "[]"为初始值
      total: 0,
      num: 0,
      datas: {
        status: '1'
      },
      tableData: [],
      detailshow: false,//查看详情弹窗开关
      detailshowData: {},//查看详情弹窗数据
    };
  },

  component: {},
  created() {

  },
  methods: {

    // 点击图片打开图片页
    toImgePage(href) {
      window.open(href, '_blank');
    },
    // 查看详情
    seeDetails(data) {
      this.detailshow = true;
      this.detailshowData = data
    },
    // 保存备注
    evaluationupdateDealRemark(item) {
      this.$api.siteConfiguration
        .evaluationupdateDealRemark({
          id: item.id,
          deal_remark: item.deal_remark
        }).then(res => {
          ////console.log('事件名',res)
          if (res.code != 0) return this.$message.error(res.data.msg)
          //接下来的操作
          // this.evaluationlist()
        })
    },
    // 重置
    reset() {
      this.datas = {
        user_id: this.$route.query.userID,
        statusRange: [],
      };
      this.evaluationlist();
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.evaluationlist();
    },
    // 获取配送单列表
    evaluationlist() {
      this.datas.user_id = this.user_id
      this.tableData = []
      this.$api.siteConfiguration.evaluationlist(this.datas).then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.data.msg);
        this.tableData = res.data.data;
        this.total = res.data.total;
        res.data.data.forEach(element => {
          if (element.porder_images != false) {
            console.log(element.porder_images);
            // element.porder_images = JSON.parse(element.porder_images)
          }
        });
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.evaluationlist();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.evaluationlist();
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  margin: 24px 0;
  position: relative;

  .row {
    display: flex;
    margin-bottom: 16px;

    .item {
      width: 240px;
      margin-right: 24px;
    }
  }

  .operation {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.No_data {
  margin: 20px auto;
  text-align: center;
  font-size: 20px;
}

.flex05 {
  flex: 0.5;
}

.flex15 {
  flex: 1.5;
}

.flex2 {
  flex: 2;
}

.template {
  height: 100%;
  overflow-y: auto;
}

.readOnly {
  pointer-events: none;
}

.blurFont {
  color: blue;
}

.redFont {
  color: red;
}

.table {
  font-size: 14px;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    height: 40px;
    background: #edeff4;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
      align-items: center !important;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .imageLI {
    flex-wrap: wrap;
    flex: 0 0 100px;

    img {
      width: 36px;
      height: 36px;
      margin: 0 6px 6px 0;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex1 {
    flex: 1;
  }

  .flex2 {
    flex: 2;
  }

  .flex15 {
    flex: 1.5;
  }

  .important {
    background-color: #e0e7f7;
    max-height: 100px;
    overflow: hidden;
  }

  ul {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #edeff4;
    transition: all 0.3s;
    height: 100px;

    &:hover {
      background-color: #fff;
    }

    /deep/ .el-input__inner {
      padding: 0;
      text-align: center;
    }
  }
}

.listShow {
  text-align: center;
}

.overallProductSatisfactionBox {
  p {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin: 5px;

    span {
      margin-right: 10px;
      min-width: 40%;
    }

    .el-button {
      margin-left: auto;
    }
  }
}

.scoreInDetail {
  h1 {
    span {
      font-size: 20px;
      font-weight: bold;
    }

    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom:40px;
  }

  h2 {
    color: red;
    margin-bottom: 15px;
  }

  ul {
    max-height: 600px;
    overflow-y: auto;

    li {
      margin-bottom: 30px;

      .row1 {
        display: flex;
        margin-bottom: 15px;
      }

      .row2 {
        display: flex;
        align-items: flex-start;

        .el-textarea {
          width: 40%;
          margin-right: 20px;

          /deep/.el-textarea__inner {
            height: 80px;
          }


        }

        .imgBox {
          display: flex;
          flex-wrap: wrap;

          .imgs {
            margin: 0 10px 10px 0;
          }
        }
      }
    }
  }
}

.backImg {
  width: 80px;
  height: 80px;
}
</style>